import React, { Component } from 'react';
import { Row, Col, Button, NavLink } from 'react-bootstrap';
import Aux from "../../hoc/_Aux";
import Card from "../../App/components/MainCard";
import withRouter from '../../App/components/withRouter';

class HelpService extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isVideoOpen: false
        }
    }
    OpenVideo = () => {
        this.setState({
            isVideoOpen: true
        })
        const script = document.createElement("script");
        script.src = "https://play.vidyard.com/embed/v4.js";
        script.async = true;
        document.body.appendChild(script);
    }
    render() {
        return (
            <Aux>
                <Row>
                    <Col>
                        <Card title=' Help '>
                            <div>
                                <h3>Topics</h3>
                                <h5><NavLink onClick={this.OpenVideo}>How to Raise Collection Request</NavLink></h5>
                            </div>
                            <Button
                                onClick={() => this.props.navigate(`/dashboard${this.props.location.search}`)} className="pull-right"><span className="tes-back"></span>
                                Back
                            </Button>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {(
                            this.state.isVideoOpen ?
                                <img
                                    alt=""
                                    style={{ width: '100%', margin: 'auto', display: 'block' }}
                                    className="vidyard-player-embed"
                                    src="https://play.vidyard.com/1cZVZJAn5B6sPdz3pCcrEf.jpg"
                                    data-uuid="1cZVZJAn5B6sPdz3pCcrEf"
                                    data-v="4"
                                    data-type="inline"
                                /> : null
                        )}
                    </Col>
                </Row>
            </Aux>
        );
    }
}

export default withRouter(HelpService);